import React, { FC } from 'react';
import ContentBgImage from 'components/energy5/structures/ContentBgImage';
import { contactHeaderBgImage } from 'assets/images/contact-us';
import useI18n from "evcharging/hooks/useI18n";

const HeaderSection: FC = () => {
  const { t } = useI18n();

  return (
    <ContentBgImage
      backgroundSrc={contactHeaderBgImage}
      title={t('contact-us.title')}
      text={t('contact-us.description')}
    />
  );
};

export default HeaderSection;
